// Func = limiting Scope for this file
var lastScrollTop = 0;
let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;



//datepicker booking
var opened = 0;
var originstart = $('#arriveInput').attr('value');
var originend = $('#departureInput').attr('value');
var opencheck = 0;
var firstClick = 0;


(function(){

	$(document).ready(function () {
		$('.sym-slides.slider').slick('unslick').slick('reinit').slick();
		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		const toggleButton = document.getElementById("menu-btn");
		const menu = document.getElementById("nav-desktop");
		const text = document.getElementById("menu-btn__text");
		console.log(toggleButton);
		if(toggleButton != null){
			toggleButton.addEventListener("click", function() {
				if (menu.classList.contains("open")) {
					text.textContent = "Menu";
					menu.classList.remove("open");
					toggleButton.classList.remove("open");
				} else {
					text.textContent = "Close";
					menu.classList.add("open");
					toggleButton.classList.add("open");
				}
			});
		}

		const toggleButtonReserve = document.getElementById("btn-reserve");
		const formContainer = document.querySelector('.form-container');
		const textReserve = document.getElementById("btn-reserve");
		if(toggleButtonReserve != null){
			toggleButtonReserve.addEventListener("click", function() {
				if (formContainer.classList.contains("open")) {
					textReserve.textContent = "book now";
					formContainer.classList.remove("open");
					toggleButtonReserve.classList.remove("open");
				} else {
					textReserve.textContent = "close";
					formContainer.classList.add("open");
					toggleButtonReserve.classList.add("open");
				}
			});
		}
		
		if (isMobile) {
			const toggleButtonClose = document.getElementById("close-menu");
			const menuMobile = document.getElementById("nav-desktop");
			if(toggleButtonClose != null){
				toggleButtonClose.addEventListener("click", function() {
					if (menuMobile.classList.contains("open")) {
						menuMobile.classList.remove("open");
						text.textContent = "Menu";
					} else {
						text.textContent = "Close";
						menuMobile.classList.add("open");
					}
				});
			}
		}
		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}


			//To create after event 
			$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
			$.datepicker._updateDatepicker = function (inst) {
				$.datepicker._updateDatepicker_original(inst);
				var afterShow = this._get(inst, 'afterShow');
				if (afterShow)
					afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
			}
	
			
			$('#datesCalendar').datepicker({
				changeMonth:false,
				numberOfMonths: 1,
				minDate:0,
				dateFormat:'mm/dd/yy',
				beforeShowDay: function (clickeddate) {
	
					$.datepicker._defaults.dateFormat = 'mm/dd/yy';
					var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, originstart);
					var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, originend);
					if (clickeddate.getTime() == startDate.getTime()) {
						return [true, "startday"];
					} else {
						if (clickeddate.getTime() == endDate.getTime()) {
							return [true, "endday"];
						} else {
							if (clickeddate.getTime() > startDate.getTime() && clickeddate.getTime() < endDate.getTime()) {
								return [true, "days"];
							} else {
								return [true, ""];
							}
						}
					}
				},
				onSelect: function (clickeddate) {
					var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, originstart);
					var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, originend);
					var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, clickeddate);
	
					if (opened == 0) {
						opened = 1;
						originstart = clickeddate;
						originend = clickeddate;
						opencheck = 0;
					} else {
						opened = 0;
						if (selectedDate <= arrive) {
							originend = originstart;
							originstart = clickeddate;
						} else {
							originend = clickeddate;
						}
						if($('#bookingBlock').hasClass('home')){
							$('#calendarContainer').fadeOut();
						}
						
					}
					$('#arriveInput').attr('value', originstart);
					$('#departureInput').attr('value', originend);
					setupDate(originstart,originend)
				
				},
				onChangeMonthYear: function () {
					opencheck = 1;
				}
			});
	
			let specifiedElement = document.getElementById('bookingBlock');


			document.addEventListener('click', function(event){
				if(specifiedElement != null){
					let isClickInside = specifiedElement.contains(event.target);
					if (!isClickInside) {
						if($('#bookingBlock').hasClass('home')){
							$('#calendarContainer').fadeOut();
						}
					}
				}
			});
			
	
			


	});



function setupDate(startt,endt){
	let newstart = startt.split('-');
	let newend = endt.split('-');
	//$('.js-fake-input').attr('value', newstart[0] + '-' + newstart[1] + '-' + newstart[2] + ' / ' + newend[0] + '-' + newend[1] + '-' + newend[2]);
}


			/*****************************************************
			OBSERVER TO ADD PARALLAX EFFECT
			/*****************************************************/
			var scrollParallax = []
			var scrolled = 0

			// screen height
			var v_height = window.innerHeight
				|| document.documentElement.clientHeight
				|| document.body.clientHeight;

			function doParallax(elm) {

				let boundes = elm.dataset.parallax.split(",") // get it from html
				//get distance in positive value
				let distance = Math.abs(boundes[0] - boundes[1])
				if (boundes[0] > boundes[1]) {
					//get distance in negative value (to do the scroll inverse)
					distance = distance * -1
				}
				//Equivalent distance using screen height + element height
				const unit_scroll = distance / (v_height + elm.offsetHeight)
				let temp = 0

				let topElement = 0;
				let element = elm;

				let id_elem = elm.dataset.parallaxid

				do {
					topElement += element.offsetTop || 0;
					element = element.offsetParent;
				} while (element)

				let parallaxFunction = function () {
					//Obtain the distance between top screen and document top 0
					scrolled = document.documentElement.scrollTop || window.pageYOffset
					//Distance of bottom page to top of the element
					let relative_distance = scrolled + v_height - topElement
					//transpoling data to move the parallax element relative to the scroll of all the screen
					temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
					//console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
					elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
				}

				scrollParallax[id_elem] = parallaxFunction

				window.addEventListener('scroll', scrollParallax[id_elem])

			}

			let observers_parallax = document.querySelectorAll(".js-parallax-element")

			if (observers_parallax) {
				let options_parallax = {
					root: null, // relative to document viewport
					rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
					threshold: 0 // visible amount of item shown in relation to root
				}

				function handler_parallax(entries, observer) {
					let entry;
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							doParallax(entry.target)
						} else {
							let id_elem = entry.target.dataset.parallaxid
							window.removeEventListener('scroll', scrollParallax[id_elem])
						}
					})
				}

				let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
				let counter = 1
				observers_parallax.forEach(function (element) {
					observable_parallax.observe(element)
					element.dataset.parallaxid = counter
					counter++
				})
			}
			/********************************************************************************
			END OF OBSERVER TO ADD PARALLAX EFFECT
			***********************************************************************************/


		  //ease movement
			function easeInOutQuart(t, b, c, d) {
				if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
				return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
			}
			//window offset
			function offset(el) {
				var rect = el.getBoundingClientRect(),
					scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
					scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
			}

			function titleCase(str) {
				var splitStr = str.toLowerCase().split(' ');
				for (var i = 0; i < splitStr.length; i++) {
					// You do not need to check if i is larger than splitStr length, as your for does that for you
					// Assign it back to the array
					splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
				}
				// Directly return the joined string
				return splitStr.join(' '); 
			}


	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}